import { ELicensesCat, IUser } from '../../../../../../shared/src/lib/@ngrx/user/user.model';

export class UsersUtilityService {
  static getCompanyCode(user?: Partial<IUser>) {
    if (!user) return null;
    return user.licenseCat ? user.licenseCat == ELicensesCat.company ? user.licenseCode : null : user.company
  }
}